import React, {Component} from "react"
import {Entity} from 'aframe-react'

import MicImage from "../assets/icons/mic.png"

import fixed from "../components-aframe/fixed"

import Quicksand from "../assets/fonts/quicksand.fnt"
import QuicksandSheet from "../assets/fonts/quicksand.png"


class TutorialClick extends Component {

    render() {

        // console.log(this.props)

        return (
            <Entity position={{x: 0, y: 1.6, z: 0}} visible={this.props.tutorial.active} fixed>

                <Entity position={{x:0, y:0.4, z: -5}}>

                    {/*<Entity
                        primitive="a-image"

                        material={{
                            transparent: true
                        }}

                        src={MicImage}

                        width={50}
                        height={89}

                        position={{
                            x: 0,
                            y: 0.5,
                            z: 0
                        }}

                        scale="0.005 0.005 1"
                    />*/}

                    <Entity
                        primitive="a-text"
                        value={"Tap The Button To Active Mic"}

                        color="#282828"

                        
                        text={{
                            font: Quicksand,
                            fontImage: QuicksandSheet,
                        }}

                        align="center"
                    ></Entity>

                </Entity>




            </Entity>
        );
    }
}

export default TutorialClick;



// WEBPACK FOOTER //
// ./src/components/tutorial-click.js